module.exports = __webpack_public_path__ + "img/hlw_images_yzs.b877d43b.png";